import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-2 py-2 float-right w-8 active:scale-90" }
const _hoisted_2 = { class: "!h-full px-12 overflow-y-scroll overflow-x-hidden pt-8 mb-5 relative" }
const _hoisted_3 = { class: "flex justify-between fixed top-[1.5rem] z-10 h-10 bg-white w-[85%]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "-mt-2 border-[1px] mb-5 w-[60rem]" }, null, -1)
const _hoisted_5 = { class: "text-[0.8rem] text-v_dark_blue font-[700] grid grid-cols-7 gap-[1rem]" }
const _hoisted_6 = { class: "ml-5" }
const _hoisted_7 = { class: "relative w-20 h-[2rem] mt-[-0.5rem]" }
const _hoisted_8 = { class: "overflow" }
const _hoisted_9 = { class: "text-v_green" }
const _hoisted_10 = { class: "text-v_green" }
const _hoisted_11 = { class: "text-v_red" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", { className: "mt-2 border-[1px] mb-5 opacity-[50%] w-[60em]" }, null, -1)

import { ref, PropType } from "vue"
import { ModalContainer, ModalnfoNoteContainer } from "../atoms"
import { Commission } from "@/utils/interfaces"


export default /*#__PURE__*/_defineComponent({
  __name: 'NoteInformationModal',
  props: {
	commissions: { type: Array as PropType<Commission[]>, required: true },
},
  setup(__props) {

let headers = ref([
	"Comissão",
	"Nota",
	"Cliente",
	"Total",
	"C.Bruto",
	"Ajuste",
	"Desconto",
])


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_unref(ModalContainer), { class: "!z-10" }, {
    default: _withCtx(() => [
      _createVNode(_unref(ModalnfoNoteContainer), { width: 15 }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "pr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeNoteInfoModal', false)))
          }, [
            _createElementVNode("button", _hoisted_1, [
              _createVNode(_component_v_icon, { icon: "mdi-close-thick" })
            ])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headers), (items, index) => {
                return (_openBlock(), _createElementBlock("h1", {
                  key: index,
                  class: "text-v_dark_gray3"
                }, _toDisplayString(items), 1))
              }), 128))
            ]),
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.commissions, (items, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(index + 1), 1),
                  _createElementVNode("p", null, _toDisplayString(items.note), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(items.client), 1)
                  ]),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(items.total), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(items.brute), 1),
                  _createElementVNode("p", null, _toDisplayString(items.adjustment), 1),
                  _createElementVNode("p", _hoisted_11, _toDisplayString(items.discount), 1)
                ]),
                _hoisted_12
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})